/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */

import { editLabelBatch, getLabelBatch } from '@/api/content/content.js'
import * as XLSX from 'xlsx'
import FileSaver from 'file-saver'
import Cookies from "js-cookie";
import {getToken} from "@/utils/auth";

export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

//验证大于0整数
export function checkIntNumber(value){
  var type="^[0-9]*$";
  var r=new RegExp(type);
  var flag=r.test(value);
  if(!flag){
    return false;
  }else{
    return true;
  }
}

//验证大于等于0的整数
export function checkIsPositiveInteger(value){
  var reg = /^(0|[1-9][0-9]*)$/
  var r = new RegExp(reg)
  var flag = r.test(value)
  if (!flag) {
    return false
  } else {
    return true
  }
}

//验证金额
export function checkMoney(value){
  var type="^(([1-9]{1}\\d*)|(0{1}))(\\.\\d{1,2})?$";
  var r=new RegExp(type);
  var flag=r.test(value);
  if(!flag){
    return false;
  }else{
    return true;
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function setFilter(condition, type = 1) {
  const filter = {}
  const op = {}
  Object.values(condition).forEach((item, index) => {
    if (item !== '' && item != null) {
      if (typeof item === 'object') {
        if (item.value !== '' && item.value != null) {
          this.$set(filter, Object.keys(condition)[index], item.value)
          this.$set(op, Object.keys(condition)[index], item.op)
        }
      } else {
        this.$set(filter, Object.keys(condition)[index], item)
        this.$set(op, Object.keys(condition)[index], '=')
      }
    }
  })
  // return [JSON.stringify(filter), JSON.stringify(op)]
  if(type == 2){
    return {
      op: encodeURI(JSON.stringify(op)),
      filter: encodeURI(JSON.stringify(filter))
    }
  }else{
    return {
      op: JSON.stringify(op),
      filter: JSON.stringify(filter)
    }
  }

}

const formatNumber = n => {
  n = n.toString()
  return n[1] ? n : '0' + n
}

// 获取当前月份有多少天
function getDaysByMonth(year, month) {
  return new Date(year, month, 0).getDate()
}

export function formatDate(date, format) {
  if (date) {
    date = new Date(date)
  } else {
    date = new Date()
  }
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  const days = getDaysByMonth(year, month, 0)
  const week = date.getDay()
  const weekArray = ['日', '一', '二', '三', '四', '五', '六']
  if (format == 'yyyy') {
    // 获取年
    return { date: year, text: year + '年' }
  } else if (format == 'yyyy-MM') {
    // 获取年月
    return {
      date: [year, month].map(formatNumber).join('-'),
      text: year + '年' + formatNumber(month) + '月'
    }
  } else if (format == 'MM-dd') {
    // 获取月日
    return {
      date: [month, day].map(formatNumber).join('-'),
      text: formatNumber(month) + '月' + formatNumber(day) + '日'
    }
  } else if (format == 'yyyy-MM-dd') {
    // 获取年月日
    return {
      year: year,
      month: month,
      yearMonth: year + '年' + formatNumber(month) + '月',
      weekIndex: week,
      week: weekArray[week],
      days: days,
      day: formatNumber(day),
      date: [year, month, day].map(formatNumber).join('-'),
      timeStamp: Date.parse([year, month, day].map(formatNumber).join('-')),
      text: year + '年' + formatNumber(month) + '月' + formatNumber(day) + '日'
    }
  } else if (format == 'yyyy-MM-dd hh:mm') {
    // 获取年月日 时分
    const today  = new Date();
    const today_year = today.getFullYear()
    const today_month = today.getMonth() + 1
    const today_day = today.getDate();
    var dateTime = [year, month, day].map(formatNumber).join('-');
    var today_dateTime = [today_year, today_month, today_day].map(formatNumber).join('-');
    if(dateTime === today_dateTime){
      dateTime = '今天';
    }
    return {
      date: dateTime + ' ' + [hour, minute].map(formatNumber).join(':'),
      text: year + '年' + formatNumber(month) + '月' + formatNumber(day) + '日'
    }
  } else if (format == 'yyyy-MM-dd hh:mm:ss') {
    // 获取年月日 时分秒
    return {
      date: [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':'),
      text: year + '年' + formatNumber(month) + '月' + formatNumber(day) + '日' + ' ' + formatNumber(hour) + '时' + formatNumber(minute) + '分' + formatNumber(second) + '秒',
      str: `${year}${formatNumber(month)}${formatNumber(day)}${formatNumber(hour)}${formatNumber(minute)}${formatNumber(second)}`
    }
  }
}

export function calcFormatTime(time) {
  // 计算出相差天数
  var days = Math.floor(time / (24 * 3600 * 1000))

  // 计算出小时数
  var leave1 = time % (24 * 3600 * 1000) // 计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000))
  // 计算相差分钟数
  var leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000))
  // 计算相差秒数
  var leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
  var seconds = Math.ceil(leave3 / 1000)

  return formatNumber(hours + days * 24) + ':' + formatNumber(minutes) + ':' + formatNumber(seconds);
}


// 定义导出表格触发事件
export function exportExcelFile(tabId, fileName) {

  var fix = document.querySelector(".el-table__fixed"); //如果是都给了fixed样式
  // var fix = document.querySelector(".el-table__fixed-right"); //如果是只有右边有fixed样式
  var wb;
  if (fix) {
    //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
    wb = XLSX.utils.table_to_book(
      document.querySelector(`#${tabId}`).removeChild(fix),
      { raw: true }
    );
    document.querySelector(`#${tabId}`).appendChild(fix);
  } else {
    wb = XLSX.utils.table_to_book(
      document.querySelector(`#${tabId}`),
      { raw: true }
    );
  }
  const date = formatDate("", "yyyy-MM-dd hh:mm:ss");
  const name = fileName + date.str + '.xlsx';

  console.log(wb);
  /* 获取二进制字符串作为输出 */
  var wbout = XLSX.write(wb, {
    bookType: 'xlsx',
    bookSST: true,
    type: 'array'
  })
  try {
    FileSaver.saveAs(
      // Blob 对象表示一个不可变、原始数据的类文件对象。
      new Blob([wbout], { type: 'application/octet-stream' }),
      // 设置导出文件名称
      name
    )
  } catch (e) {
    if (typeof console !== 'undefined') console.log(e, wbout)
  }
  return wbout
}


export function exportOrderExcel(param, apiUrl){
  // console.log( process.env.VUE_APP_BASE_API + '/admin/order.vip_order/lists');
  let href = process.env.VUE_APP_BASE_API + apiUrl;
  href = href + '?' + changeParam(param) + 'token='+getToken();
  // console.log(this.changeParam(param));
  window.open(href, '_blank')
}

export function changeParam(param){
  let hrefStr = "";
  for (let i in param) {
    // console.log(`键名：${i}；键值：${param[i]}`);
    hrefStr += i + "=" + param[i] + '&';
  }
  return hrefStr;
}



//批量处理标签
export function editInfoLabel(type, id, label, callback) {
  var param = {
    type: type,//标签类型:1=服务,2=合同,3=律师,4=资讯,5=法律问答,6=法律法规,7=律师讲堂,8=知识科普
    title: label,
    collection_id: id,
  }
  editLabelBatch(param).then((res)=>{
    if(res.code == 1){
      callback(res);
    }
  }).catch((err)=>{})

}


//批量处理标签
export function getInfoLabel(type, id, callback) {
  var param = {
    type: type,//标签类型:1=服务,2=合同,3=律师,4=资讯,5=法律问答,6=法律法规,7=律师讲堂,8=知识科普  9课程， 10 用户指南
    collection_id: id,
  }
  getLabelBatch(param).then((res)=>{
    callback(res);
  }).catch((err)=>{})

}

//隐藏手机号中间四位
export function hideMobile(val) {
  var reg = /^(\d{3})\d{4}(\d{4})$/;
  if(val != null){
    return val.replace(reg, "$1****$2");
  }else{
    return val;
  }
}

//检测导出权限
export function checkExportAuth(val) {
  //当前有导出功能的权限按钮
  const exportRules = [
    {id: 2, label: "销售收入明细"},
    {id: 3, label: "发票管理"},
    {id: 14, label: "服务订单"},
    {id: 15, label: "合同订单"},
    {id: 16, label: "订阅订单"},
    {id: 31, label: "电话咨询订单"},
    {id: 38, label: "律友包订单"},
    {id: 40, label: "售后订单"},
    {id: 41, label: "提现订单"},
    {id: 43, label: "悬赏咨询订单"},
    {id: 34, label: "入住律师申请"},
    {id: 35, label: "入住律所申请"},
    {id: 36, label: "咨询客服评价管理"},
    {id: 9999, label: "聊天记录"},
  ];
  var nodeRules = Cookies.get('nodeRules') || '';
  if(nodeRules !== ''){
    var nodeRulesArr = nodeRules.split(',').map((res)=>Number(res));
    return nodeRulesArr.includes(val)
  }else{
    return false;
  }
}




